var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronRight = function SvgChevronRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 13 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 19.406 8.038 11 0 2.594 2.48 0 13 11 2.48 22 0 19.406z",
    fill: "currentColor"
  })));
};
export default SvgChevronRight;